<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M10 7.72416V4.00016H11.3333V2.66683C11.3333 2.31321 11.1929 1.97407 10.9428 1.72402C10.6928 1.47397 10.3536 1.3335 10 1.3335H6C5.64638 1.3335 5.30724 1.47397 5.05719 1.72402C4.80714 1.97407 4.66667 2.31321 4.66667 2.66683V4.00016H6V7.72416L4.19533 8.86216C4.13331 8.92397 4.08411 8.99743 4.05059 9.07832C4.01707 9.15921 3.99987 9.24593 4 9.3335V10.6668C4 10.8436 4.07024 11.0132 4.19526 11.1382C4.32029 11.2633 4.48986 11.3335 4.66667 11.3335H7.33333V13.3335L8 14.6668L8.66667 13.3335V11.3335H11.3333C11.5101 11.3335 11.6797 11.2633 11.8047 11.1382C11.9298 11.0132 12 10.8436 12 10.6668V9.3335C12.0001 9.24593 11.9829 9.15921 11.9494 9.07832C11.9159 8.99743 11.8667 8.92397 11.8047 8.86216L10 7.72416Z"
            fill="currentColor"
        />
    </svg>
</template>
